import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '@/engineproject/default/common/assets/images/appboss/android-chrome-192x192.png'


const _hoisted_1 = ["src", "title"]
const _hoisted_2 = {
  key: 1,
  class: "noImageContainer"
}
const _hoisted_3 = { class: "noImageTextPart" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "firstImageOnly",
  src: _imports_0,
  title: "Aucune image associée, affichage de l'image par défaut de l'application"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    ($props.aAdDoc.OADData.ADDefaultAttDoc)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "firstImageOnly",
          src: $props.aAdDoc.OADData.ADDefaultAttDoc,
          title: ($props.aAdDoc.OADData.ADDefaultAttDocLicense !== undefined) ? $props.aAdDoc.OADData.ADDefaultAttDocLicense : ''
        }, null, 8, _hoisted_1))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, _toDisplayString($setup.t($props.aAdDoc.OADData.ADCatsInUnivers)), 1)
          ]),
          _hoisted_4
        ]))
  ]))
}